import { Injectable, signal } from '@angular/core';

export type UILanguage = 'en' | 'nl' | 'fr';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public readonly language = signal<UILanguage>(this.readInitialLanguage());

  constructor() {
    document.documentElement.lang = this.language();
  }

  public setLanguage(next: string): void {
    const language: UILanguage = next === 'en' || next === 'nl' || next === 'fr' ? next : 'nl';
    this.language.set(language);
    localStorage.setItem('bgi_lang', language);
    document.documentElement.lang = language;
  }

  private readInitialLanguage(): UILanguage {
    const stored = localStorage.getItem('bgi_lang');
    if (stored === 'en' || stored === 'nl' || stored === 'fr') {
      return stored;
    }
    return 'nl';
  }
}
